import IuHomeBase from "../../SHARED/components/IuHomeBase";
import { IU_HOME_VARIANT } from "../../SHARED/pgHomeConfig";

const AdminHome = () => <IuHomeBase variant={IU_HOME_VARIANT.admin} />;

export default AdminHome;
